import { type IQuestionBase } from "features/Library/Common/models";
import { asQuestionsMap } from "features/Library/Common/QuestionsForm/Questions/QuestionsBuilder/QuestionProvider";
import { type RatingScale, type SurveyQuestion } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/types";
import { SurveyQuestionType } from "features/Library/Surveys/types/models";
import { SurveyTextQuestion } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/SurveyFields/SurveyTextQuestion";
import { SurveyRateQuestion } from "../SurveyFields/SurveyRateQuestion";

/* istanbul ignore next */
export const QuestionsMap = asQuestionsMap({
  [SurveyQuestionType.MultipleChoiceTextQuestion]: {
    Component: SurveyTextQuestion,
    castQuestion: (Question: IQuestionBase) => Question as SurveyQuestion<string>,
  },
  [SurveyQuestionType.SingleChoiceTextQuestion]: {
    Component: SurveyTextQuestion,
    castQuestion: (Question: IQuestionBase) => Question as SurveyQuestion<string>,
  },
  [SurveyQuestionType.FreeText]: {
    Component: SurveyTextQuestion,
    castQuestion: (Question: IQuestionBase) => Question as SurveyQuestion<string>,
  },
  [SurveyQuestionType.RatingScale]: {
    Component: SurveyRateQuestion,
    castQuestion: (Question: IQuestionBase) => Question as SurveyQuestion<RatingScale>,
  },
});
